jQuery(document).ready(newsroomInit);

function newsroomInit(){

	setupSliders();
	setupPressReleaseShowAllButton();
	
}

function setupSliders() {
	
	jQuery('.news-slider:not(.slick-initialized)').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		rows: 1,
		slidesPerRow: 3,
		dots: true,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		responsive: [
		{
		  breakpoint: 680,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	  ]
	});
	
}

function setupPressReleaseShowAllButton() {
	
	jQuery("#show-all-press-releases").on("click", function(){
		
		jQuery(".press-release-container.hide").removeClass("hide");
		jQuery(this).remove();
		
	});
	
}
